// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Login.css — KinetiQ Login Page
   Layout: Navbar (via Navbar.css) sits on top (position: fixed).
           Below it: two-column split — dark left panel + light
           right panel card.
           The WHOLE PAGE scrolls (browser scrollbar), and the
           footer sits at the end of the page.
   ============================================================ */

/* ── Page shell ──
   min-height (not height) so the page can grow past the viewport
   and scroll normally. padding-top reserves space for the 68px
   fixed navbar. Keep overflow visible so the fixed navbar is
   never clipped.                                                */
.login-page-shell {
  position: fixed;               /* own scroll container: independent of html/body CSS */
  top: 68px;                     /* starts right below the 68px fixed navbar           */
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;              /* <-- the whole page (content + footer) scrolls here */
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  box-sizing: border-box;
}

/* ── Two-column content area ──
   flex: 1 → fills the space above the footer on tall screens,
   so the footer is pushed to the bottom of the viewport.
   No fixed height / overflow → panels grow with their content. */
.login-page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1 0 auto;
}

/* ════════════════════════════════════════════════════════════
   LEFT PANEL — dark gradient hero
   ════════════════════════════════════════════════════════════ */
.login-left {
  background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 52px 52px 44px;
  position: relative;
  overflow: hidden;              /* only clips the decorative bubble */
  color: #FFFFFF;
}

/* Radial teal glow */
.login-left::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 70% 60% at 75% 40%, rgba(0,194,168,0.12) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

/* Decorative bottom-left bubble */
.login-left::after {
  content: '';
  position: absolute;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: rgba(0,194,168,0.06);
  bottom: -80px;
  left: -60px;
  pointer-events: none;
  z-index: 0;
}

/* All direct children above pseudo-overlays */
.login-left > * {
  position: relative;
  z-index: 1;
}

/* ── Hero copy block ── */
.login-hero-copy {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
}

/* Badge */
.login-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0,194,168,0.15);
  border: 1px solid rgba(0,194,168,0.35);
  color: #00C2A8;
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 99px;
  width: fit-content;
}

.login-badge::before {
  content: '';
  width: 7px;
  height: 7px;
  background: #00C2A8;
  border-radius: 50%;
  flex-shrink: 0;
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1;   transform: scale(1);   }
  50%       { opacity: 0.5; transform: scale(1.4); }
}

.login-hero-copy h1 {
  font-size: clamp(1.7rem, 2.8vw, 2.4rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.025em;
  color: #FFFFFF;
}

.login-hero-copy h1 em {
  font-style: normal;
  color: #00C2A8;
}

.login-hero-copy p {
  font-size: 0.97rem;
  color: rgba(255,255,255,0.72);
  line-height: 1.72;
  max-width: 400px;
}

/* Feature checklist */
.login-feature-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-top: 4px;
}

.login-feature-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: rgba(255,255,255,0.82);
}

.login-feature-list li .check {
  width: 22px;
  height: 22px;
  background: #00C2A8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.68rem;
  color: #0D1F35;
  font-weight: 800;
}

/* Web pill */
.login-web-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 99px;
  padding: 8px 16px 8px 10px;
  font-size: 0.82rem;
  color: rgba(255,255,255,0.65);
  width: fit-content;
  margin-top: 28px;
}

.login-web-pill .pill-icon {
  width: 26px;
  height: 26px;
  background: #00C2A8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  flex-shrink: 0;
}

/* ════════════════════════════════════════════════════════════
   RIGHT PANEL — form area
   ════════════════════════════════════════════════════════════ */
.login-right {
  background: #F4F8FB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 32px 32px 40px;
}

/* ── Card ── */
.login-card {
  width: 100%;
  max-width: 440px;
  background: #FFFFFF;
  border: 1.5px solid #B8D4E0;
  border-radius: 20px;
  padding: 40px 40px 36px;
  box-shadow: 0 8px 48px rgba(10,50,90,0.13);
}

/* ── Card header ── */
.login-card-header {
  margin-bottom: 28px;
}

.login-card-label {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #0B8DA6;
  margin-bottom: 8px;
}

.login-card-header h2 {
  font-size: 1.8rem;
  font-weight: 800;
  color: #1A3C6E;
  line-height: 1.15;
  letter-spacing: -0.022em;
  margin-bottom: 6px;
}

.login-card-header p {
  font-size: 0.9rem;
  color: #6B7A8D;
  line-height: 1.6;
}

/* ── Form ── */
.login-form {
  display: flex;
  flex-direction: column;
}

.login-form-group {
  margin-bottom: 20px;
}

.login-form-group label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #1A3C6E;
  margin-bottom: 7px;
  letter-spacing: 0.02em;
}

.login-form-group input {
  display: block;
  width: 100%;
  background: #EBF4F8;
  border: 1.5px solid #B8D4E0;
  border-radius: 6px;
  padding: 13px 16px;
  color: #0D1F35;
  font-size: 0.94rem;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;
  -webkit-appearance: none;
}

.login-form-group input::placeholder {
  color: #9BAABB;
  font-size: 0.9rem;
}

.login-form-group input:hover {
  border-color: #0B8DA6;
}

.login-form-group input:focus {
  border-color: #0B8DA6;
  background: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(11,141,166,0.13);
}

/* ── Error banner ── */
.login-error {
  background: rgba(244,162,97,0.11);
  border: 1px solid rgba(244,162,97,0.45);
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 0.85rem;
  color: #b85e1a;
  font-weight: 500;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.45;
}

.login-error::before {
  content: '⚠';
  font-size: 1rem;
  flex-shrink: 0;
}

/* ── Submit button ── */
.login-submit-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #00C2A8;
  color: #0D1F35;
  font-weight: 700;
  font-size: 0.97rem;
  padding: 15px 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
  box-shadow: 0 4px 18px rgba(0,194,168,0.32);
  font-family: 'Inter', 'Segoe UI', sans-serif;
  margin-top: 6px;
  letter-spacing: 0.01em;
}

.login-submit-btn:hover {
  background: #00a896;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0,194,168,0.42);
}

.login-submit-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0,194,168,0.25);
}

/* ── Divider ── */
.login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 22px 0;
  color: #6B7A8D;
  font-size: 0.8rem;
}

.login-divider::before,
.login-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: #B8D4E0;
}

/* ── Register row ── */
.login-register-row {
  text-align: center;
  font-size: 0.9rem;
  color: #6B7A8D;
}

.login-register-row a {
  color: #0B8DA6;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
}

.login-register-row a:hover {
  color: #1A3C6E;
  text-decoration: underline;
}

/* ── Footer note ── */
.login-card-footer-note {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #B8D4E0;
  font-size: 0.76rem;
  color: #9BAABB;
  text-align: center;
  line-height: 1.6;
}

/* ════════════════════════════════════════════════════════════
   RESPONSIVE
   ════════════════════════════════════════════════════════════ */
@media (max-width: 860px) {
  .login-page {
    grid-template-columns: 1fr;
  }

  .login-left {
    display: none;               /* hide hero panel; navbar carries the brand */
  }

  .login-right {
    background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);
    padding: 40px 20px;
  }

  .login-card {
    border: none;
    box-shadow: 0 12px 48px rgba(0,0,0,0.25);
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 32px 22px 28px;
    border-radius: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;;;;;;;iEAOiE;;AAEjE;;;;kEAIkE;AAClE;EACE,eAAe,gBAAgB,uDAAuD;EACtF,SAAS,sBAAsB,uDAAuD;EACtF,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB,eAAe,uDAAuD;EACtF,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;;;iEAGiE;AACjE;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,eAAe,qCAAqC;EACpE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iGAAiG;EACjG,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,IAAI,mBAAmB,IAAI;EAChD,YAAY,YAAY,EAAE,qBAAqB,EAAE;AACnD;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,2CAA2C;EAC3C,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa,gBAAgB,8CAA8C;EAC7E;;EAEA;IACE,0EAA0E;IAC1E,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================================\n   Login.css — KinetiQ Login Page\n   Layout: Navbar (via Navbar.css) sits on top (position: fixed).\n           Below it: two-column split — dark left panel + light\n           right panel card.\n           The WHOLE PAGE scrolls (browser scrollbar), and the\n           footer sits at the end of the page.\n   ============================================================ */\n\n/* ── Page shell ──\n   min-height (not height) so the page can grow past the viewport\n   and scroll normally. padding-top reserves space for the 68px\n   fixed navbar. Keep overflow visible so the fixed navbar is\n   never clipped.                                                */\n.login-page-shell {\n  position: fixed;               /* own scroll container: independent of html/body CSS */\n  top: 68px;                     /* starts right below the 68px fixed navbar           */\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;              /* <-- the whole page (content + footer) scrolls here */\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  box-sizing: border-box;\n}\n\n/* ── Two-column content area ──\n   flex: 1 → fills the space above the footer on tall screens,\n   so the footer is pushed to the bottom of the viewport.\n   No fixed height / overflow → panels grow with their content. */\n.login-page {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  flex: 1 0 auto;\n}\n\n/* ════════════════════════════════════════════════════════════\n   LEFT PANEL — dark gradient hero\n   ════════════════════════════════════════════════════════════ */\n.login-left {\n  background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 52px 52px 44px;\n  position: relative;\n  overflow: hidden;              /* only clips the decorative bubble */\n  color: #FFFFFF;\n}\n\n/* Radial teal glow */\n.login-left::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(ellipse 70% 60% at 75% 40%, rgba(0,194,168,0.12) 0%, transparent 70%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Decorative bottom-left bubble */\n.login-left::after {\n  content: '';\n  position: absolute;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  background: rgba(0,194,168,0.06);\n  bottom: -80px;\n  left: -60px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* All direct children above pseudo-overlays */\n.login-left > * {\n  position: relative;\n  z-index: 1;\n}\n\n/* ── Hero copy block ── */\n.login-hero-copy {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 22px;\n}\n\n/* Badge */\n.login-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(0,194,168,0.15);\n  border: 1px solid rgba(0,194,168,0.35);\n  color: #00C2A8;\n  font-size: 0.76rem;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  padding: 6px 14px;\n  border-radius: 99px;\n  width: fit-content;\n}\n\n.login-badge::before {\n  content: '';\n  width: 7px;\n  height: 7px;\n  background: #00C2A8;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: pulse-dot 2s ease-in-out infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1;   transform: scale(1);   }\n  50%       { opacity: 0.5; transform: scale(1.4); }\n}\n\n.login-hero-copy h1 {\n  font-size: clamp(1.7rem, 2.8vw, 2.4rem);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.025em;\n  color: #FFFFFF;\n}\n\n.login-hero-copy h1 em {\n  font-style: normal;\n  color: #00C2A8;\n}\n\n.login-hero-copy p {\n  font-size: 0.97rem;\n  color: rgba(255,255,255,0.72);\n  line-height: 1.72;\n  max-width: 400px;\n}\n\n/* Feature checklist */\n.login-feature-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n  margin-top: 4px;\n}\n\n.login-feature-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  color: rgba(255,255,255,0.82);\n}\n\n.login-feature-list li .check {\n  width: 22px;\n  height: 22px;\n  background: #00C2A8;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 0.68rem;\n  color: #0D1F35;\n  font-weight: 800;\n}\n\n/* Web pill */\n.login-web-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(255,255,255,0.07);\n  border: 1px solid rgba(255,255,255,0.15);\n  border-radius: 99px;\n  padding: 8px 16px 8px 10px;\n  font-size: 0.82rem;\n  color: rgba(255,255,255,0.65);\n  width: fit-content;\n  margin-top: 28px;\n}\n\n.login-web-pill .pill-icon {\n  width: 26px;\n  height: 26px;\n  background: #00C2A8;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n/* ════════════════════════════════════════════════════════════\n   RIGHT PANEL — form area\n   ════════════════════════════════════════════════════════════ */\n.login-right {\n  background: #F4F8FB;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 32px 32px 40px;\n}\n\n/* ── Card ── */\n.login-card {\n  width: 100%;\n  max-width: 440px;\n  background: #FFFFFF;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 20px;\n  padding: 40px 40px 36px;\n  box-shadow: 0 8px 48px rgba(10,50,90,0.13);\n}\n\n/* ── Card header ── */\n.login-card-header {\n  margin-bottom: 28px;\n}\n\n.login-card-label {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: #0B8DA6;\n  margin-bottom: 8px;\n}\n\n.login-card-header h2 {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #1A3C6E;\n  line-height: 1.15;\n  letter-spacing: -0.022em;\n  margin-bottom: 6px;\n}\n\n.login-card-header p {\n  font-size: 0.9rem;\n  color: #6B7A8D;\n  line-height: 1.6;\n}\n\n/* ── Form ── */\n.login-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.login-form-group {\n  margin-bottom: 20px;\n}\n\n.login-form-group label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1A3C6E;\n  margin-bottom: 7px;\n  letter-spacing: 0.02em;\n}\n\n.login-form-group input {\n  display: block;\n  width: 100%;\n  background: #EBF4F8;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 6px;\n  padding: 13px 16px;\n  color: #0D1F35;\n  font-size: 0.94rem;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;\n  -webkit-appearance: none;\n}\n\n.login-form-group input::placeholder {\n  color: #9BAABB;\n  font-size: 0.9rem;\n}\n\n.login-form-group input:hover {\n  border-color: #0B8DA6;\n}\n\n.login-form-group input:focus {\n  border-color: #0B8DA6;\n  background: #FFFFFF;\n  box-shadow: 0 0 0 3px rgba(11,141,166,0.13);\n}\n\n/* ── Error banner ── */\n.login-error {\n  background: rgba(244,162,97,0.11);\n  border: 1px solid rgba(244,162,97,0.45);\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 0.85rem;\n  color: #b85e1a;\n  font-weight: 500;\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.45;\n}\n\n.login-error::before {\n  content: '⚠';\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n/* ── Submit button ── */\n.login-submit-btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #00C2A8;\n  color: #0D1F35;\n  font-weight: 700;\n  font-size: 0.97rem;\n  padding: 15px 28px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;\n  box-shadow: 0 4px 18px rgba(0,194,168,0.32);\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  margin-top: 6px;\n  letter-spacing: 0.01em;\n}\n\n.login-submit-btn:hover {\n  background: #00a896;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0,194,168,0.42);\n}\n\n.login-submit-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0,194,168,0.25);\n}\n\n/* ── Divider ── */\n.login-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 22px 0;\n  color: #6B7A8D;\n  font-size: 0.8rem;\n}\n\n.login-divider::before,\n.login-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #B8D4E0;\n}\n\n/* ── Register row ── */\n.login-register-row {\n  text-align: center;\n  font-size: 0.9rem;\n  color: #6B7A8D;\n}\n\n.login-register-row a {\n  color: #0B8DA6;\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.login-register-row a:hover {\n  color: #1A3C6E;\n  text-decoration: underline;\n}\n\n/* ── Footer note ── */\n.login-card-footer-note {\n  margin-top: 24px;\n  padding-top: 18px;\n  border-top: 1px solid #B8D4E0;\n  font-size: 0.76rem;\n  color: #9BAABB;\n  text-align: center;\n  line-height: 1.6;\n}\n\n/* ════════════════════════════════════════════════════════════\n   RESPONSIVE\n   ════════════════════════════════════════════════════════════ */\n@media (max-width: 860px) {\n  .login-page {\n    grid-template-columns: 1fr;\n  }\n\n  .login-left {\n    display: none;               /* hide hero panel; navbar carries the brand */\n  }\n\n  .login-right {\n    background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);\n    padding: 40px 20px;\n  }\n\n  .login-card {\n    border: none;\n    box-shadow: 0 12px 48px rgba(0,0,0,0.25);\n  }\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 32px 22px 28px;\n    border-radius: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
